import { FormControl, FormGroup, Validators } from "@angular/forms";

export class SaleTemplate {
  saleTemplateId: number;
  name: string;
  description: string;
  createdBy: number;
  createdDate: any;
  isActive: boolean;
  categoryCount?: number;
  categoryIds?: number[];

  static asFormGroup(template: SaleTemplate): FormGroup {
    const fg = new FormGroup({
      saleTemplateId: new FormControl(template?.saleTemplateId),
      name: new FormControl(template?.name, Validators.required),
      description: new FormControl(template?.description),
    });
    return fg;
  }
}

export class SaleTemplateCategory {
  saleTemplateCategoryId: number;
  saleTemplateId: number;
  mediaCategoryId: number;
  createdBy: number;
  createdDate: any;
}

export class SaleTemplateRequest {
  saleTemplate: SaleTemplate;
  saleTemplateCategories: SaleTemplateCategory[];
}
